import { connect } from 'react-redux'
import at from 'lodash/at'

import { fetchTechniciansAllocatedToWorkOrder } from '../../actions/technicians'
import Select from '../../components/forms/redux-single-select'

const mapStateToProps = (state, ownProps) => {
  const technicianIds = state.workOrders[ownProps.workOrderId].technicians || []
  const techs = at(state.users, technicianIds)
  const options = techs.map(tech => ({ value: tech.id, label: tech.name }))

  return {
    options,
    ...(options.length == 0 && {
      isDisabled: true,
      placeholder: 'No Techs Selected on Work Order. You must edit it to select one'
    })
  }
}


function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchTechniciansAllocatedToWorkOrder(ownProps.workOrderId))

  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Select)



// WEBPACK FOOTER //
// ./src/containers/technicians/technician-selector-container.js